export const colors = {
    pinkOne: "#F7A2AF",
    pinkTwo: "#F7ACB5",
    lightPink: "#F9D7DD",
    pinkAccent: "#F7ACB59C",
    lightBlue: "#9AF0E7",
    mediumBlue: "#96d0c9",
    darkBlue: "#31AEBE",
    darkestBlue: "#007e8e",
    blueAccent: "#B1DBD6C9",
    yellow: "#F3FBCB",
    offWhite: "#E7EFEE",
    white: "#fff",
    nearBlack: "#121212",
    darkestGray: "#1f1f1f",
}
